import { render, staticRenderFns } from "./SocialiteLogin.vue?vue&type=template&id=3dfb7aeb&scoped=true"
import script from "./SocialiteLogin.vue?vue&type=script&lang=js"
export * from "./SocialiteLogin.vue?vue&type=script&lang=js"
import style0 from "./SocialiteLogin.vue?vue&type=style&index=0&id=3dfb7aeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb7aeb",
  null
  
)

export default component.exports